import { tryOnMounted, until } from '@vueuse/core'

/**
 * 等 getUserInfo API 完成後，若使用者未登入則呼叫 initialize callback。
 * 在 in-app browser 或使用者已登入時跳過初始化。
 */
export function useLoginSdkInit(initialize: () => void) {
  const nuxtApp = useNuxtApp()
  const { $store: store } = nuxtApp

  const isUserInfoLoading = computed<boolean>(() => store.getters['authentication/getIsUserInfoLoading'])

  tryOnMounted(async () => {
    if (windowDetector.isInAppBrowser) {
      return
    }

    // 等 getUserInfo API 完成再判斷登入狀態
    if (isUserInfoLoading.value) {
      await until(isUserInfoLoading).toBe(false)
    }

    if (store.getters['authentication/getUser']) {
      return
    }

    initialize()
  })
}
